import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './Cart.css';

const formatPrice = (price) => '৳' + price.toLocaleString('en-BD');

const Cart = () => {
  const navigate = useNavigate();
  const { cart, removeFromCart, increment, decrement, totalPrice, totalItems } = useCart();

  if (cart.length === 0) {
    return (
      <div className="cart-page">
        <header className="cart-header">
          <button className="cart-back-btn" onClick={() => navigate(-1)}>← Back</button>
          <span className="cart-header-title">My Cart</span>
        </header>
        <div className="cart-empty">
          <div className="cart-empty-icon">🛒</div>
          <p>Your cart is empty</p>
          <button className="cart-shop-btn" onClick={() => navigate('/')}>Continue Shopping</button>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <header className="cart-header">
        <button className="cart-back-btn" onClick={() => navigate(-1)}>← Back</button>
        <span className="cart-header-title">My Cart ({totalItems} items)</span>
      </header>

      <div className="cart-content">
        <div className="cart-items">
          {cart.map((item) => {
            const unitPrice = item.discount
              ? Math.round(item.price * (1 - item.discount / 100))
              : item.price;
            return (
              <div className="cart-item" key={item.id}>
                <img src={item.image} alt={item.name} className="cart-item-img" />
                <div className="cart-item-info">
                  <div className="cart-item-brand">{item.brand}</div>
                  <div className="cart-item-name">{item.name}</div>
                  <div className="cart-item-price">{formatPrice(unitPrice)}</div>
                  <div className="cart-item-controls">
                    <button onClick={() => decrement(item.id)}>−</button>
                    <span>{item.qty}</span>
                    <button onClick={() => increment(item.id)}>+</button>
                    <button className="cart-item-remove" onClick={() => removeFromCart(item.id)}>🗑</button>
                  </div>
                </div>
                <div className="cart-item-subtotal">
                  {formatPrice(unitPrice * item.qty)}
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-summary">
          <div className="cart-summary-title">Order Summary</div>
          <div className="cart-summary-row">
            <span>Subtotal ({totalItems} items)</span>
            <span>{formatPrice(totalPrice)}</span>
          </div>
          <div className="cart-summary-row">
            <span>Delivery</span>
            <span className="cart-free">FREE</span>
          </div>
          <div className="cart-summary-divider" />
          <div className="cart-summary-row cart-summary-total">
            <span>Total</span>
            <span>{formatPrice(totalPrice)}</span>
          </div>
          <button
            className="cart-checkout-btn"
            onClick={() => navigate('/checkout')}
          >
            Proceed to Checkout
          </button>
          <button className="cart-continue-btn" onClick={() => navigate('/')}>
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
